import React  from 'react';
//import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
//import NormalImg from '../common/Img';
//import LogoImg from '../participants/bicamsinlogo.jpg';
import Button from '../common/Button';
import SDMTTest from './SDMTTest';
import '../../assets/css/sdmt.css';

/*const Img = styled(NormalImg)`
  width: 300px;
  margin: 20px;
  display: block;
`;*/
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
/*const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;*/

class SDMTTestPage extends React.Component {

render() {
        //console.log();
        return (
            <div className="normalPage">
               <div className="container"> 

                   <div className="row">
                    <div className="col-md-12">   
                        <div className="col-xs-8 pull-left">
                        
                        <Link to="/bvmtr_test"><ButtonA className="btn btn-lg">Next</ButtonA></Link>
                        </div>
                    

                  

                    <SDMTTest mode="full" /> 

                    
                    </div>
                    </div>  

               </div> 
            </div>
        );
    }

}

export default SDMTTestPage;


// WEBPACK FOOTER //
// ./src/components/exam/SDMTTestPage.js